import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PrivyProvider } from "@privy-io/react-auth";
import App from "./App";
import "./index.css";

const PRIVY_APP_ID = import.meta.env.VITE_PRIVY_APP_ID || "cmp5nvtg0004p0cjrjdv4xtzy";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PrivyProvider
      appId={PRIVY_APP_ID}
      config={{
        appearance: {
          theme: "dark",
          accentColor: "#33ff33",
          logo: "/terminal.svg",
        },
        embeddedWallets: {
          createOnLogin: "all-users",
          showWalletUIs: true,
          noPromptOnSignature: false,
        },
        loginMethods: ["wallet", "email", "google", "twitter"],
        defaultChain: {
          id: 137,
          name: "Polygon",
          nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
          rpcUrls: { default: { http: ["https://polygon-rpc.com"] } },
        },
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PrivyProvider>
  </React.StrictMode>
);
